export enum EPlacementApplicationFormFields {
  CompanyName = 'companyName',
  CompanyType = 'companyType',
  Email = 'email',
  Phone = 'phone',
}

export enum EValidateActionTypes {
  ValidateAll = 'validateAll',
  ValidateByField = 'validateByField',
}
